import { Link } from "react-router-dom";
import { hotRanking } from "@/mocks/movies";

export default function HotRanking() {
  return (
    <section className="w-full px-4 md:px-6 py-8 md:py-10">
      <div className="flex items-center justify-between mb-6">
        <div className="flex items-center gap-3">
          <div className="w-7 h-7 flex items-center justify-center rounded-lg bg-accent-500/20 text-accent-400">
            <i className="ri-fire-line"></i>
          </div>
          <h2 className="text-lg md:text-xl font-bold font-heading text-foreground-50">
            热门排行
          </h2>
        </div>
        <Link
          to="/category/movie"
          className="text-sm text-foreground-400 hover:text-primary-400 transition-colors flex items-center gap-1 cursor-pointer"
        >
          查看更多
          <div className="w-4 h-4 flex items-center justify-center">
            <i className="ri-arrow-right-line text-xs"></i>
          </div>
        </Link>
      </div>

      <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-3 md:gap-4">
        {hotRanking.map((movie, index) => (
          <Link
            key={movie.id}
            to={`/article/article-${(index % 6) + 1}`}
            className="group relative flex flex-col rounded-xl overflow-hidden bg-background-900/60 border border-background-800/50 hover:border-primary-500/30 hover:bg-background-800/60 transition-all duration-300 cursor-pointer"
          >
            <div className="relative aspect-[2/3] overflow-hidden">
              <img
                src={movie.coverImage}
                alt={movie.title}
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
              />
              <div className="absolute top-2 left-2 w-7 h-7 flex items-center justify-center rounded-lg bg-background-950/80 text-sm font-bold text-primary-400">
                {index + 1}
              </div>
              <div className="absolute top-2 right-2 flex items-center gap-1 px-2 py-0.5 rounded-md bg-background-950/70 text-xs text-accent-400">
                <div className="w-3 h-3 flex items-center justify-center">
                  <i className="ri-star-fill text-[10px]"></i>
                </div>
                {movie.rating}
              </div>
            </div>
            <div className="p-3">
              <h3 className="text-sm font-semibold text-foreground-100 group-hover:text-primary-400 transition-colors line-clamp-1">
                {movie.title}
              </h3>
              <p className="text-xs text-foreground-500 mt-1">
                {movie.year} / {movie.region}
              </p>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}